import { useContext, useEffect, useState } from "react"
import Head from "next/head"
import { NextPage } from "next"
import { Container, Col, Modal, Row } from "react-bootstrap"
import { Page, ActionRow } from "@styled/dashboard"
import Link from "next/link"
import { useRouter } from "next/router"
import { toast } from "react-toastify"
import Header from "@modules/Common/components/Header"
import { StyledSpan } from "@styled/Link"
import { useCookies } from "react-cookie"
import { getMessaging, isSupported, getToken } from "firebase/messaging"
import { AppContext } from "AppContext"
import { StyledButton } from "@modules/Common/styled"
import { addEvent } from "@utils/gtm"
// import DailyActivity from "@modules/Dashboard/components/DailyActivity"
import { addDays } from "date-fns"
import { firebaseApp } from "@utils/firebase"
import { useUpdateProfileMutation } from "@generated/graphql"
import { styled } from "styled-components"

const StyledDailyActivity = styled.div`
  border-radius: 16px;
  background: var(--bs-secondary);
  padding: 48px 36px;
  text-align: left;
  @media (max-width: 601px) {
    padding: 24px 12px 18px 24px;
  }
`

const Dashboard: NextPage = () => {
  const router = useRouter()
  const { state } = useContext(AppContext)
  const [isNotificationBlocked, setIsNotificationBlocked] = useState(false)

  const [cookies, setCookie] = useCookies(["firebaseToken"])
  const [updateProfileMutation] = useUpdateProfileMutation()

  async function showNotification() {
    setIsNotificationBlocked(false)
    const supported = await isSupported()
    if (supported) {
      const messaging = getMessaging(firebaseApp)
      getToken(messaging, { vapidKey: process.env.NEXT_PUBLIC_FIREBASE_MESSAGING_WEB_PUSH_NOTIFICATION_KEY!! }).then(token => {
        setCookie("firebaseToken", true, {
          expires: addDays(new Date(), 3),
          sameSite: "strict"
        })
        return updateProfileMutation({
          variables: {
            data: {
              notificationToken: {
                set: token
              },
              notificationDevice: {
                set: "WEB"
              }
            }
          }
        })
      }).catch(error => {
        console.error(error)
        if (cookies.firebaseToken === undefined) {
          setIsNotificationBlocked(true)
        }
        setCookie("firebaseToken", false, {
          expires: addDays(new Date(), 3),
          sameSite: "strict"
        })
      })
    }
  }

  useEffect(() => {
    if (cookies.firebaseToken === undefined) {
      showNotification()
    }
  }, [cookies])

  useEffect(() => {
    if (router.query.payment_status === "Credit") {
      addEvent({
        "event": "product_purchased",
        "user_id": state.user?.id
      })
      toast("Your payment is successful and you shall receive further details soon.", {
        type: "success"
      })
    }
  }, [router.query])

  return <>
    <Head>
      <title>Dashboard | MySkillShaala</title>
    </Head>
    <Page>
      <Header />
      <Container>
        {/* <DailyActivity /> */}
        <Row>
          <Col lg={{ span: 10, offset: 1 }}>
            <StyledDailyActivity>
              Looking for Activity of the Day, we&apos;re on a break for a few days and are coming up with much more fun quizzes and activities. Stay tuned
            </StyledDailyActivity>
          </Col>
        </Row>
        <ActionRow>
          <Link href={"/activities"} legacyBehavior>
            <Col xs={6} sm={6} lg={3} className="action activities tour-step-activities">
              <StyledSpan>ACTIVITIES</StyledSpan>
            </Col>
          </Link>
          <Link href={"/explorations"} legacyBehavior>
            <Col xs={6} sm={6} lg={3} className="action explorations tour-step-bit-learning">
              <StyledSpan>TIDBITS</StyledSpan>
            </Col>
          </Link>
          <Link href={"/workshops"} legacyBehavior>
            <Col xs={6} sm={6} lg={3} className="action workshops tour-step-workshops">
              <StyledSpan>WORKSHOPS</StyledSpan>
            </Col>
          </Link>
          <Link href={"/products"} legacyBehavior>
            <Col xs={6} sm={6} lg={3} className="action products tour-step-products">
              <StyledSpan>STORE</StyledSpan>
            </Col>
          </Link>
        </ActionRow>
      </Container>
      <Modal size="lg" centered aria-labelledby="contained-modal-title-vcenter" show={isNotificationBlocked} onHide={() => setIsNotificationBlocked(false)} backdrop="static">
        <Modal.Header closeButton>
          <h1 style={{ textAlign: "center", width: "100%" }}>Get Important Updates</h1>
        </Modal.Header>
        <Modal.Body className="bg-light-gray" style={{ padding: "16px 32px", textAlign: "center" }}>
          We&apos;ll notify you about new Activity Releases, Workshops and XP Earnings.
          <br /><br />
          <StyledButton onClick={() => showNotification()}>
            Yes notify me
          </StyledButton>
        </Modal.Body>
      </Modal>
    </Page>
  </>
}

export default Dashboard
